@switch (displayMode()) {

    @case(DisplayMode.FullName)
    {
        <span [id]="roomContent().id">{{ roomContent().fullName()  }}</span>
    }

    @case (DisplayMode.Code) 
    {
        @if(roomContent().code()) {
            <span [id]="roomContent().id">{{ roomContent().code()  }}</span>
        } @else {
            <span [id]="roomContent().id">{{ roomContent().name()  }}</span>
        }
    }

    @case (DisplayMode.Name) 
    {
        <span [id]="roomContent().id">{{ roomContent().name()  }}</span>
    }
    

}


